import axios from "axios";
import { API_URL } from "./../../../config/constant";

export const generateToken = () =>
  axios.post(API_URL + "token/generate-token", { user_id: "0" });

export const verifyPanNumber = (pan) =>
  axios.post(API_URL + "api-auth/verify-pan-number-v3", { pan });

export const verifyGstNumber = (gst) =>
  axios.post(API_URL + "api-auth/verify-gst-number", { gst });

export const verifyAccountNumber = ({ accountNumber, accountHolderName, ifscCode }) =>
  axios.post(API_URL + "api-auth/verify-account-number", {
    accountNumber,
    accountHolderName,
    ifscCode,
  });

export const lookupAddressByPincode = (pincode) =>
  axios.get("https://api.postalpincode.in/pincode/" + pincode);

export const lookupBankInfoByIfsc = (ifsc) =>
  axios.get("https://ifsc.razorpay.com/" + ifsc);

export const submitPartnerApplication = (payload) => {
  const formData = new FormData();
  Object.entries(payload.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  Object.entries(payload.files).forEach(([key, file]) => {
    if (file) formData.append(key, file);
  });
  return axios.post(API_URL + "partner/save", formData);
};
